import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import Spinner from "../components/Spinner";
import BrandMark from "../components/BrandMark";
import { TRYON_SERVER_URL } from "../config";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { setAccessToken, setRefreshToken, setUserData, setUserID } from "../store/AuthActions";
import { useAuthentication } from "../Authentication";
import { selectAuthenticated } from "../selectors";
import { clearAppStorage } from "../Utils/storage";
import { Eye, EyeOff } from "lucide-react";

export default function Verification() {

    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { isAuthenticated } = useAuthentication();
    const authenticated = useSelector(selectAuthenticated)

    const {
        username = "",
        first_name = "",
        last_name = "",
        email = "",
        password = "",
    } = location.state || {};

    console.log("email", email)

    // Access the username from state
    const [otp, setOtp] = useState("");
    const [showError, setShowError] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("This is an error");
    const [otpRegenerated, setOtpRegenerated] = useState(false);
    const [spinner, setSpinner] = useState(false);

    const checkAuthentication = useCallback(async () => {
        try {
            const userAuthenticated = await isAuthenticated();
            if (userAuthenticated) {
                if (location.state !== null) {
                    navigate(location.state.path)
                } else {
                    navigate("/");
                }
            }
        } catch (error) {
            console.error('Error checking authentication:', error);

            if (error.message && error.message.toLowerCase().includes('network')) {
                console.error('Network error, redirecting to login page');
                navigate("/login");
            }
        }
    }, [dispatch, isAuthenticated, navigate]);

    useEffect(() => {
        console.log("Authenticated:", authenticated)
        if (!authenticated) {
            checkAuthentication();
        }
    }, []);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const submitForm = async () => {
        setErrorMessage("");
        setShowError(false);

        if (email === "" || otp === "") {
            setErrorMessage("Enter valid OTP");
            setOtpRegenerated(false);
            setShowError(true);
            setSpinner(false);
            return;
        }

        try {
            const formData = new FormData();
            formData.append('email', email);
            formData.append('otp', otp);

            await verifyUser(formData);
        } catch (error) {
            setErrorMessage(error?.response?.data?.message || "Invalid email or otp")
            setOtpRegenerated(false);
            setShowError(true)
            setSpinner(false)
        }
    };

    const verifyUser = async (formData) => {
        try {
            const response = await axios.post(`${TRYON_SERVER_URL}/api/v1/user/verify/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            const loginFormData1 = new FormData();
            loginFormData1.append('email', email);
            loginFormData1.append('password', password);
            console.log("login user", loginFormData1)

            await loginUser(loginFormData1);
            setSpinner(false)
            navigate("/signin");

        } catch (error) {
            throw error;
        }
    };


    const loginUser = async (formData) => {
        try {
            const response = await axios.post(`${TRYON_SERVER_URL}/api/v1/user/token/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            console.log("status:", response)
            const { access, refresh } = response.data;
            console.log('Access token received:', access);
            clearAppStorage();
            dispatch(setAccessToken(access));
            dispatch(setRefreshToken(refresh));
            isAuthenticated().then(r => {
            });
            fetchUserData(access).then(r => {
            })
            // navigate to onboarding (will redirect to playground if already completed)
            navigate("/onboarding");
        } catch (error) {
            // setErrorMessage("Invalid username or password")
            // setShowError(true)
            throw error;
        }
    };

    const regenerateOtp = async () => {
        try {
            // Simulating an API call for OTP regeneration
            const response = await fetch(`${TRYON_SERVER_URL}/api/v1/user/otp/regenerate`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: email }),
            });

            if (!response.ok) {
                throw new Error("Failed to regenerate OTP. Please try again.");
            }

            setOtpRegenerated(true);
            setErrorMessage(""); // Clear any previous errors
        } catch (error) {
            setShowError(true);
            setErrorMessage(error.message);
            setOtpRegenerated(false);
            setOtpRegenerated(false);
        }
    };

    const fetchUserData = async (accessToken) => {
        try {
            console.log("access in fetch data", accessToken)
            const response = await fetch(`${TRYON_SERVER_URL}/api/v1/user/get/`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const data = await response.json();
                const userid = data?.id
                console.log("userid", userid)
                dispatch(setUserID(userid));
                const dataWithoutPassword = { ...data, password: undefined }; // Omit the password field
                dispatch(setUserData(JSON.stringify(dataWithoutPassword)));
            } else {
                console.error('Failed to fetch user data');
            }
        } catch (error) {
            console.error('Error fetching user data:', error);

        }
    };

    const handleVerify = (e) => {
        e.preventDefault();
        setSpinner(true);
        submitForm();
    };

    return (
        <div className="flex h-screen flex-col overflow-y-auto bg-ground">
            <div className="flex min-h-full w-full items-start justify-center px-4 py-8">
                <div className="mx-auto flex w-full max-w-lg justify-center">
                    <div className="w-full rounded-2xl bg-white p-6 shadow-[0_0_0_1px_var(--hairline)]">
                        <div className="mb-6 flex items-center justify-center gap-3">
                            <BrandMark alt="" className="h-9 w-9 shrink-0 object-contain"/>
                            <div className="font-Mulish text-lg font-semibold text-secondary">
                                TryOn AI
                            </div>
                        </div>

                        <form action="#">
                            <label htmlFor="otp" className="mb-1.5 block font-Mulish text-sm text-graphite">
                                Code
                            </label>
                            <p className="mb-3 font-Mulish text-sm text-graphite">
                                We sent a code to your email.
                            </p>
                            <div className="relative">
                                <input
                                    type={passwordVisible ? "text" : "password"}
                                    name="otp"
                                    id="otp"
                                    placeholder="Enter the code"
                                    value={otp}
                                    onChange={(e) => {
                                        setErrorMessage("");
                                        setShowError(false);
                                        setOtp(e.target.value);
                                    }}
                                    className="w-full rounded-lg border-0 bg-white px-3 py-2.5 pr-10 text-center font-Mulish text-sm text-secondary shadow-[0_0_0_1px_var(--hairline)] placeholder:text-graphite focus:outline-none focus:ring-2 focus:ring-primary-200"
                                    required
                                />
                                {passwordVisible ? <Eye onClick={togglePasswordVisibility} aria-label="Hide" className="absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 cursor-pointer text-gray-400" /> : <EyeOff onClick={togglePasswordVisibility} aria-label="Show" className="absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 cursor-pointer text-gray-400" />}
                            </div>

                            <button
                                type="submit"
                                onClick={handleVerify}
                                className={`mt-4 inline-flex w-full items-center justify-center rounded-full px-4 py-2.5 font-Mulish text-sm font-semibold ${
                                    spinner
                                        ? "bg-primary-100 text-primary-800"
                                        : "bg-primary-700 text-white shadow-[0_12px_28px_-10px_rgba(190,49,32,0.65)]"
                                }`}
                            >
                                {spinner ? <Spinner /> : "Verify"}
                            </button>

                            {showError && (
                                <p className="mt-4 border-l-2 border-primary-700 pl-3 font-Mulish text-sm text-secondary">
                                    {errorMessage}
                                </p>
                            )}

                            {otpRegenerated && (
                                <p className="mt-4 text-center font-Mulish text-sm text-graphite">
                                    A new code is on its way.
                                </p>
                            )}

                            <div className="mt-4 text-center">
                                <span className="font-Mulish text-sm text-graphite">
                                    Didn't get the code?{" "}
                                </span>
                                <button
                                    type="button"
                                    onClick={regenerateOtp}
                                    className="font-Mulish text-sm text-primary-700 hover:underline"
                                >
                                    Send a new code
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}